<template>
  <div class="p-4">
    <p v-if="!headings.length" class="text-sm leading-relaxed text-[#1c4848]/50">Headings you add show up here, so you can jump between sections.</p>
    <nav v-else aria-label="Page outline" class="space-y-0.5">
      <button
        v-for="heading in headings"
        :key="heading.pos"
        type="button"
        class="block min-h-9 w-full truncate rounded-lg px-2 py-1.5 text-left text-sm text-[#1c4848] hover:bg-[#1c4848]/5"
        :class="heading.level === 1 ? 'font-bold' : heading.level === 2 ? 'ps-5' : 'ps-8 text-[#1c4848]/70'"
        @click="jump(heading.pos)"
      >{{ heading.text || 'Untitled' }}</button>
    </nav>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  editor: { type: Object, required: true },
  version: { type: Number, default: 0 },
});

const headings = computed(() => {
  void props.version;
  const list = [];
  props.editor.state.doc.forEach((node, pos) => {
    if (node.type.name === 'heading') list.push({ pos, level: node.attrs.level, text: node.textContent });
  });
  return list;
});

function jump(pos) {
  props.editor.chain().focus(pos + 1).run();
  props.editor.view.nodeDOM(pos)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}
</script>
